<div class="container">

  <app-content-base [parent]="'SystemShopContent'" [location]="eContentLocation.Content"></app-content-base>

  <div class="d-flex flex-column-reverse flex-lg-row justify-content-around">
    <div class="left-container mt-5 mb-4">
      <div class="fw-bold fs-2" i18n="@@MaintenanceUnderConstruction">Website is under Construction</div>
      <div class="fs-3 my-3" i18n="@@MaintenanceBePatient">Please be patient. We will be back soon!</div>
      <button (click)="contactOpen()" class="btn btn-secondary btn-pretty" i18n="@@MaintenanceContactUs">Contact
        Us</button>
    </div>

    <div class="right-container my-4">
      <img class="brand-logo mb-4" alt="Construction Image">
      <div class="fw-bold fs-1" i18n="@@MaintenanceWeComeBack">We come back to serve you</div>
    </div>
  </div>

</div>
